var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionButtonViewSecret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.103,
    height: 15.769,
    viewBox: "0 0 28.103 15.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_View",
    transform: "translate(6123.772 7077.454)",
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_13609",
    "data-name": "Path 13609",
    transform: "translate(-6123.772 -7077.454)",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.052,0C21.812,0,28.1,7.885,28.1,7.885s-6.291,7.885-14.052,7.885S0,7.885,0,7.885,6.291,0,14.052,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.0516357421875 1.500002861022949 C 8.643802642822266 1.500002861022949 3.869113922119141 5.912841796875 2.004552841186523 7.886244297027588 C 3.864870071411133 9.86128044128418 8.625110626220703 14.26902198791504 14.0516357421875 14.26902198791504 C 19.4577693939209 14.26902198791504 24.23124313354492 9.858869552612305 26.0970401763916 7.884559631347656 C 24.23042678833008 5.909390449523926 19.45734596252441 1.500002861022949 14.0516357421875 1.500002861022949 M 14.0516357421875 2.86102294921875e-06 C 21.81213569641113 2.86102294921875e-06 28.10327529907227 7.884512424468994 28.10327529907227 7.884512424468994 C 28.10327529907227 7.884512424468994 21.81213569641113 15.76902198791504 14.0516357421875 15.76902198791504 C 6.291126251220703 15.76902198791504 -3.814697265625e-06 7.884512424468994 -3.814697265625e-06 7.884512424468994 C -3.814697265625e-06 7.884512424468994 6.291126251220703 2.86102294921875e-06 14.0516357421875 2.86102294921875e-06 Z",
    stroke: "none",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    transform: "translate(-6114.919 -7074.766)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.198,
    cy: 5.198,
    r: 5.198,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.198,
    cy: 5.198,
    r: 4.448,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButtonViewSecret);
export default __webpack_public_path__ + "static/media/action_button_view_secret.801662a0fc6eded31b3cffe96d08b159.svg";
export { ForwardRef as ReactComponent };